import React from 'react';
import FilterToggleGroup, { FilterToggleRow } from '../../common/list/FilterToggleGroup';

const techStatus = [
  { id: 0, value: '', label: '전체', color: null },
  { id: 1, value: '0', label: '제안영업', color: 'info' },
  { id: 2, value: '1', label: '착수보고', color: 'error' },
  { id: 3, value: '2', label: '분석설계', color: 'success' },
  { id: 4, value: '3', label: '구축(이행)', color: 'secondary' },
  { id: 5, value: '4', label: '완료(검수)', color: 'warning' },
];

const prjTyps = [
  { id: 0, value: '', label: '전체', color: null },
  { id: 1, value: 'N', label: '프로젝트', color: 'info' },
  { id: 2, value: 'M', label: '유지보수', color: 'success' },
];

// 단계/타입 필터 - chancemng 설계(공통 FilterToggleGroup) 적용(2026-10-22).
const TechStatusList = ({ searchGrade, onChangeGrade, searchPrjTyp, onChangePrjTyp }) => {
  return (
    <FilterToggleRow>
      <FilterToggleGroup label="단계" options={techStatus} value={searchGrade} onChange={onChangeGrade} />
      <FilterToggleGroup label="타입" options={prjTyps} value={searchPrjTyp} onChange={onChangePrjTyp} />
    </FilterToggleRow>
  );
};

export default TechStatusList;
